module.exports = {
  siteTitle: 'Oxgeo | Professional Writer | Content Freelancer',
  siteDescription:
    'Sade Agard is a UK-based professional writer learning the scopes of crypto finance, Ethereum, NFT, and DeFi.',
  siteKeywords:
    'Sade Agard, oxgeo, Professional Writer, Content Freelancer, face mask, face mask detection, content maker, freelance writer, pepper content, jamshedpur, amdocs, bit, mesra',
  siteUrl: 'https://oxgeo.github.io/',
  siteLanguage: 'en_US',
  googleAnalyticsID: '',
  googleVerification: '',
  name: 'Sade Agard',
  location: 'UK, United Kingdom',
  email: 'sademagard@live.com',
  github: 'https://github.com/oxgeo',
  twitterHandle: '@oxgeo',
  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/oxgeo',
    },
    {
      name: 'Linkedin',
      url: 'https://linkedin.com/in/sade-agard',
    },
    {
      name: 'Codepen',
      url: 'https://codepen.io/oxgeo',
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/oxgeo',
    },
    {
      name: 'Twitter',
      url: 'https://twitter.com/oxgeo_',
    },
  ],

  navLinks: [
    // {
    //   // name: 'Education',
    //   // url: '/#about',
    // },
    {
      name: 'My Experience',
      url: '/#jobs',
    },
    {
      name: 'Projects',
      url: '/#projects',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  navHeight: 100,

  colors: {
    green: '#64ffda',
    navy: '#0a192f',
    darkNavy: '#020c1b',
  },

  srConfig: (delay = 200) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor: 0.25,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
